module.exports = __webpack_public_path__ + "img/logo.9a389a2d.png";